(function () {
  var speed = 300;
  var oneOpen = true;

  function slideDown(el) {
    el.style.overflow = 'hidden';
    el.style.height = '0';
    el.style.display = 'block';
    var target = el.scrollHeight + 'px';
    el.style.transition = 'height ' + speed + 'ms ease';
    requestAnimationFrame(function () {
      el.style.height = target;
    });
    el.addEventListener('transitionend', function handler() {
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
    });
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.height = el.scrollHeight + 'px';
    el.style.transition = 'height ' + speed + 'ms ease';
    requestAnimationFrame(function () {
      el.style.height = '0';
    });
    el.addEventListener('transitionend', function handler() {
      el.style.display = 'none';
      el.style.height = '';
      el.style.overflow = '';
      el.style.transition = '';
      el.removeEventListener('transitionend', handler);
    });
  }

  function init() {
    var accordions = document.querySelectorAll('.js-accordion');
    if (!accordions.length) return;

    // Ensure only one item is active on init
    if (oneOpen) {
      var allActive = document.querySelectorAll('.js-accordion-item.active');
      for (var i = 1; i < allActive.length; i++) {
        allActive[i].classList.remove('active');
      }
    }

    // Show bodies of initially active items
    var activeBodies = document.querySelectorAll('.js-accordion-item.active > .js-accordion-body');
    for (var j = 0; j < activeBodies.length; j++) {
      activeBodies[j].style.display = 'block';
    }

    // Delegate click on headers
    document.addEventListener('click', function (e) {
      var header = e.target.closest('.js-accordion-header');
      if (!header) return;

      var item = header.closest('.js-accordion-item');
      var accordion = header.closest('.js-accordion');
      if (!item || !accordion) return;

      // Close other open items if oneOpen
      if (oneOpen) {
        var siblings = accordion.querySelectorAll(':scope > .js-accordion-item.active');
        for (var k = 0; k < siblings.length; k++) {
          if (siblings[k] !== item) {
            siblings[k].classList.remove('active');
            var body = siblings[k].querySelector('.js-accordion-body');
            if (body) slideUp(body);
          }
        }

        // Also close items in parent containers
        var container = header.closest('.main-container');
        if (container) {
          var otherItems = container.querySelectorAll('.js-accordion-item.active');
          for (var l = 0; l < otherItems.length; l++) {
            if (otherItems[l] !== item) {
              otherItems[l].classList.remove('active');
              var otherBody = otherItems[l].querySelector('.js-accordion-body');
              if (otherBody) slideUp(otherBody);
            }
          }
        }
      }

      // Toggle clicked item
      var targetBody = item.querySelector('.js-accordion-body');
      if (!targetBody) return;

      item.classList.toggle('active');
      if (item.classList.contains('active')) {
        slideDown(targetBody);
      } else {
        slideUp(targetBody);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
